module.exports = __webpack_public_path__ + "static/img/28.52524722.gif";